import github from "./github";
import heart from "./heart";
import notFound from "./notFound";
import wallet from "./wallet";
import filepdf from "./file-pdf";
import images from "./images";
import eye from "./eye";
import eyeCrossed from "./eye-crossed";
import rotateRight from "./rotate-right";
import upload from "./upload";

const icon = {
    github,
    heart,
    notFound,
    upload,
    eye,
    eyeCrossed,
    wallet,
    filepdf,
    images,
    rotateRight,
};

export default icon;
